module.exports = __webpack_public_path__ + "img/ic-exterieur12h.b288c36a.svg";